import { FETCH_DATA } from "../actions/types";

export default (state = [{ error: "" }], action) => {
  switch (action.type) {
    case FETCH_DATA:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dataReducer.js